import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ToggleNextHandoutMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  feature_next_handout_enabled: Types.Scalars['Boolean'];
}>;


export type ToggleNextHandoutMutation = { __typename?: 'Mutation', adminUpdateUser?: { __typename?: 'User', id: string, feature_next_handout_enabled: boolean } | null };


export const ToggleNextHandoutDocument = gql`
    mutation ToggleNextHandout($id: ID!, $feature_next_handout_enabled: Boolean!) {
  adminUpdateUser(
    id: $id
    item: {feature_next_handout_enabled: $feature_next_handout_enabled}
  ) {
    id
    feature_next_handout_enabled
  }
}
    `;
export type ToggleNextHandoutMutationFn = Apollo.MutationFunction<ToggleNextHandoutMutation, ToggleNextHandoutMutationVariables>;

/**
 * __useToggleNextHandoutMutation__
 *
 * To run a mutation, you first call `useToggleNextHandoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNextHandoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNextHandoutMutation, { data, loading, error }] = useToggleNextHandoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feature_next_handout_enabled: // value for 'feature_next_handout_enabled'
 *   },
 * });
 */
export function useToggleNextHandoutMutation(baseOptions?: Apollo.MutationHookOptions<ToggleNextHandoutMutation, ToggleNextHandoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleNextHandoutMutation, ToggleNextHandoutMutationVariables>(ToggleNextHandoutDocument, options);
      }
export type ToggleNextHandoutMutationHookResult = ReturnType<typeof useToggleNextHandoutMutation>;
export type ToggleNextHandoutMutationResult = Apollo.MutationResult<ToggleNextHandoutMutation>;
export type ToggleNextHandoutMutationOptions = Apollo.BaseMutationOptions<ToggleNextHandoutMutation, ToggleNextHandoutMutationVariables>;